export default class Banco {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.logradouro = '';
        this.bairro = '';
        this.cidade = '';
        this.cep = '';
        this.uf = '';
        this.gerente = '';
        this.gerenteTelefone = '';
        this.gerenteCelular = '';
        this.gerenteEmail = '';
        this.bancoId = 0;
        this.agencia = '';
        this.contaCorrente = '';
        this.numeroContrato = 0;
        this.carteira = '';
        this.sequenciaRemessa = 0;
        this.situacao = 'A';
        this.planoContaContabilId;
        this.planoContaContabil;

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome;
        this.logradouro = model.logradouro;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.cep = model.cep;
        this.uf = model.uf;
        this.gerente = model.gerente;
        this.gerenteTelefone = model.gerenteTelefone;
        this.gerenteCelular = model.gerenteCelular;
        this.gerenteEmail = model.gerenteEmail;
        this.bancoId = model.bancoId;
        this.agencia = model.agencia;
        this.contaCorrente = model.contaCorrente;
        this.numeroContrato = model.numeroContrato;
        this.carteira = model.carteira;
        this.sequenciaRemessa = model.sequenciaRemessa;
        this.situacao = model.situacao;
        this.planoContaContabilId = model.planoContaContabilId;
        this.planoContaContabil = model.planoContaContabil;
    }
}